module.exports = __webpack_public_path__ + "media/images/flags/32/Denmark-49f5dba7e461bcda01d442dde9e62311.png";